import Image from 'next/image';
import React from 'react';
import SmartphoneIcon from '@/assets/icons/smartphone.svg';
import IdCardIcon from '@/assets/icons/id-card.svg';
import MapIcon from '@/assets/icons/map.svg';

interface serviceItem {
  image: React.ReactNode;
  title: string;
  description?: string;
  downloadUrl?: string;
}

export const landingPageServiceData: serviceItem[] = [
  {
    image: <Image src="/images/www-service.svg" width={72} height={24} className="h-12" alt="" />,
    title: 'GPS Tracking Web Based Software',
    description:
      'View Last position vessel, Route view, and History view from everywhere, anywhere, reliable server with Linux Based. 99% uptime server.',
    downloadUrl: '/assets/catalogue.pdf',
  },
  {
    image: (
      <Image src="/images/tracking-service.svg" width={40} height={24} className="h-16" alt="" />
    ),
    title: 'Seamless Integration',
    description:
      'We offer bespoke systems tailored to your specific requirements, seamlessly integrable into your internal infrastructure.',
  },
  {
    image: (
      <Image src="/images/export-service.svg" width={72} height={24} className="h-12" alt="" />
    ),
    title: 'Data Documentation',
    description:
      'Generate and export detailed vessel reports, including route history, engine telemetry, and speed logs for compliance and operational analysis.',
  },
  {
    image: (
      <Image src="/images/iridium-service.png" width={72} height={24} className="h-16" alt="" />
    ),
    title: ' Iridium EdgeSolar Terminal',
    description:
      'Device powered by the sun. Maintenance-free device as the power of the sun recharges its batteries providing 8+ years of usable service. We are supplier authorization iridium edge solar in Indonesia.',
    downloadUrl: '/assets/iridium.pdf',
  },
  {
    image: <Image src="/images/solar-service.png" width={60} height={24} className="h-12" alt="" />,
    title: 'Globalstar Solar Cell',
    description:
      'Device powered by the sun. Maintenance-free device as the power of the sun recharges its batteries providing 8+ years of usable service.',
    downloadUrl: '/assets/solar.pdf',
  },
  {
    image: (
      <Image src="/images/skywave-service.png" width={60} height={24} className="h-12" alt="" />
    ),
    title: 'Skywave Terminal',
    description:
      'Industrial-grade satellite communication terminal offering reliable, two-way messaging and tracking even on the most remote maritime routes.',
    downloadUrl: '/assets/skywave.pdf',
  },
  {
    image: (
      <Image src="/images/sc1000.png" width={60} height={24} className="h-12" alt="" />
    ),
    title: 'SC1000 Solarcell',
    description:
      'Robust, solar-powered satellite tracking terminal by Orbcomm. Designed for multi-year maintenance-free operations with intelligent power management.',
    downloadUrl: '/assets/sc1000.pdf',
  },
  {
    image: (
      <Image src="/images/skywave-service.png" width={60} height={24} className="h-12" alt="" />
    ),
    title: 'RPM & HOUR METER SENSOR (optional)',
    description: 'Display information of Engine RPM as text report or Graphic report.',
  },
  {
    image: <Image src="/images/mam-service.png" width={72} height={24} className="h-12" alt="" />,
    title: 'Missi Asset Monitor',
    description: 'Reliable, simple and cost-effective satellite tracking',
    downloadUrl: '/assets/mam.pdf',
  },
];

export interface ClientDataItem {
  description: string;
  image: string;
  name: string;
  role: string;
}

export const clientsData: ClientDataItem[] = [
  {
    description:
      ' It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. ',
    image: '/images/client/01.jpg',
    name: 'Calvin Carlo',
    role: 'Manager',
  },
  {
    description: ` The most well-known dummy text is the Lorem Ipsum, which is said to have originated in the 16th century. `,
    image: '/images/client/02.jpg',
    name: 'Christa Smith',
    role: 'Manager',
  },
  {
    description:
      ' One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others. ',
    image: '/images/client/03.jpg',
    name: 'Jemina CLone',
    role: 'Manager',
  },
  {
    description:
      ' Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. ',
    image: '/images/client/04.jpg',
    name: 'Smith Vodka',
    role: 'Manager',
  },
  {
    description:
      ' There is now an abundance of readable dummy texts. These are usually used when a text is required. ',
    image: '/images/client/05.jpg',
    name: 'Cristino Murfi',
    role: 'Manager',
  },
  {
    description:
      ' According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero. ',
    image: '/images/client/06.jpg',
    name: 'Cristino Murfi',
    role: 'Manager',
  },
];

export const contactData = [
  {
    icon: SmartphoneIcon,
    title: 'Sales Support',
    link: 'https://wa.me/6281382609869',
    contact: '+62 813-8260-9869',
  },
  {
    icon: IdCardIcon,
    title: 'Email Support',
    link: 'mailto:support@mitos.id',
    contact: 'support@mitos.id',
  },
  {
    icon: MapIcon,
    title: 'Technical Support',
    link: 'https://wa.me/6289634555083',
    contact: '0896 3455 5083',
  },
];
